export default __webpack_public_path__ + "static/media/select-check-active.4c46c091.svg";